export default {
  'refunds.sectionTitle': 'Refunds',
  'refunds.title': 'Refunds',
  'refunds.tab.all': 'All',
  'refunds.tab.processing': 'Processing',
  'refunds.tab.completed': 'Completed',
};
